/* Hauser MX — comportamiento inmersivo de la ficha de propiedad (Fase 8).
 *
 * La ficha es la página que vende: es donde alguien decide si pide una cita.
 * Aquí viven cuatro piezas, todas colgadas del bucle único del núcleo:
 *
 *   1. Precio que MORFEA hacia la barra inferior (GSAP Flip) en vez de que
 *      aparezca una barra de la nada.
 *   2. Specs que cuentan al entrar, con el icono reaccionando al mismo tiempo.
 *   3. Amenidades que se asientan una a una, como fichas que caen en su sitio.
 *   4. "También podría gustarte" arrastrable con inercia real.
 */
(function () {
  'use strict';

  var H = window.Hauser;
  if (!H) return;

  var ficha = document.querySelector('.hauser-ficha');
  if (!ficha) return;

  /* ── 1. El precio que morfea hacia la barra ───────────────────────── */

  /* Antes la barra inferior simplemente aparecía cuando el precio original
     salía de pantalla: dos elementos distintos, uno se va y otro llega. Con
     Flip es UN SOLO precio que viaja de su sitio en la ficha hasta la barra,
     y vuelve cuando scrolleas hacia arriba. El visitante no pierde de vista la
     cifra en ningún momento — que es justo lo que se necesita cuando está
     decidiendo. */
  function precioMorfa() {
    var bloque = ficha.querySelector('[data-hauser-precio-observar]');
    var barra = document.querySelector('[data-hauser-sticky-bar]');
    if (!bloque || !barra) return;

    var origen = bloque.querySelector('.hauser-ficha__precio');
    var destino = barra.querySelector('.hauser-sticky-bar__precio');
    if (!origen || !destino) return;

    var Flip = window.Flip;
    var gsap = window.gsap;

    /* Sin Flip (o en nivel `flat`) se conserva el comportamiento de siempre:
       la barra aparece y ya. Nada depende de esto. */
    if (!Flip || !gsap || H.tier === 'flat') return;

    /* El truco: el precio de la barra existe en el HTML pero se mantiene
       invisible; lo que se ve viajando es SIEMPRE el precio original, que se
       reparenta al contenedor de la barra y vuelve. Así no hay dos cifras
       distintas que puedan desincronizarse. */
    destino.style.visibility = 'hidden';
    var casaOrigen = origen.parentNode;
    var enBarra = false;

    function mover(aBarra) {
      if (aBarra === enBarra) return;
      enBarra = aBarra;

      var estado = Flip.getState(origen);
      if (aBarra) destino.parentNode.insertBefore(origen, destino);
      else casaOrigen.insertBefore(origen, casaOrigen.firstChild);

      Flip.from(estado, {
        duration: 0.55,
        ease: 'expo.out',
        absolute: true,
        /* Sin esto el precio salta al final del recorrido cuando el layout de
           la barra todavía no se ha asentado. */
        onComplete: function () { gsap.set(origen, { clearProps: 'position,top,left,width,height' }); }
      });
    }

    /* SOLO por debajo de 750px. La barra inferior es `display:none` a partir
       de ahí (hauser-ficha.css:480), así que en escritorio mover el precio
       dentro de ella lo hacía DESAPARECER — bug que metí yo y que se vio al
       medir el DOM, no al leer el código. Se usa matchMedia propio y no
       `Hauser.media()` porque el umbral de la barra es 750, no los 990 del
       cambio de scroller; por debajo de 750 el scroller es siempre el
       documento, así que no hace falta pasar `scroller`. */
    var mm = gsap.matchMedia();
    mm.add('(max-width: 749px)', function () {
      var ST = window.ScrollTrigger;
      if (!ST) return;
      var st = ST.create({
        trigger: bloque,
        /* Cuando el precio original sale por arriba del viewport. */
        start: 'bottom top+=80',
        onEnter: function () { mover(true); },
        onLeaveBack: function () { mover(false); }
      });
      return function () { st.kill(); mover(false); };
    });
  }

  /* ── 2. Specs que cuentan ─────────────────────────────────────────── */

  /* Cada spec ("3 recámaras", "175 m² de construcción") cuenta su número al
     entrar. El icono se dibuja al mismo tiempo con `stroke-dashoffset`: es el
     equivalente en código de una máquina de estados de Rive — el gráfico
     reacciona por su cuenta, no es un GIF. */
  function specs() {
    var lista = ficha.querySelectorAll('.hauser-ficha__spec-item');
    if (!lista.length || !window.gsap || H.tier === 'flat') return;

    Array.prototype.forEach.call(lista, function (item) {
      var span = item.querySelector('span');
      var icono = item.querySelector('svg');
      if (!span) return;

      var texto = span.textContent.trim();
      var m = texto.match(/^([\d.,]+)(.*)$/);

      H.enVista(item, function () {
        if (icono) {
          window.gsap.fromTo(
            icono,
            { scale: 0.55, rotate: -14, opacity: 0 },
            { scale: 1, rotate: 0, opacity: 1, duration: 0.6, ease: 'back.out(2.2)' }
          );
        }
        if (!m) {
          window.gsap.fromTo(span, { opacity: 0, x: -8 }, { opacity: 1, x: 0, duration: 0.5, ease: 'power2.out' });
          return;
        }
        var destino = parseFloat(m[1].replace(/,/g, ''));
        var resto = m[2];
        /* Los decimales importan: "2.5 baños" no puede convertirse en "3". */
        var decimales = (m[1].split('.')[1] || '').length;
        if (!isFinite(destino)) return;
        var st = { n: 0 };
        window.gsap.to(st, {
          n: destino,
          duration: 1.1,
          ease: 'power2.out',
          onUpdate: function () {
            span.textContent = st.n.toFixed(decimales).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + resto;
          },
          onComplete: function () { span.textContent = texto; }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
    });
  }

  /* ── 3. Amenidades que se asientan ────────────────────────────────── */

  /* Entran una a una con un rebote corto, como fichas cayendo en su sitio.
     No se usa Matter.js aquí a propósito: son hasta 20 chips y montar un
     motor de física para una entrada de medio segundo es desproporcionado.
     El rebote de GSAP da la misma lectura por una fracción del coste. */
  function amenidades() {
    var chips = ficha.querySelectorAll('.hauser-ficha__chip');
    if (!chips.length || !window.gsap || H.tier === 'flat') return;

    var contenedor = ficha.querySelector('.hauser-ficha__chips');
    if (!contenedor) return;

    H.enVista(contenedor, function () {
      window.gsap.fromTo(
        chips,
        { y: 18, opacity: 0, scale: 0.94 },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 0.62,
          ease: 'back.out(1.7)',
          stagger: { each: 0.035, from: 'start' }
        }
      );
    }, { rootMargin: '0px 0px -8% 0px' });
  }

  /* ── 4. Similares con arrastre e inercia ──────────────────────────── */

  /* En escritorio la rejilla de 3 se queda como está (caben). En móvil pasa a
     ser una fila que se arrastra con inercia real: sueltas y sigue corriendo
     hasta frenar, con topes elásticos en los extremos. Es el gesto que la
     gente ya hace en cualquier app de fotos. */
  function similares() {
    var grid = ficha.querySelector('.hauser-ficha__similares-grid');
    if (!grid) return;

    var Draggable = window.Draggable;
    if (!Draggable || H.tier === 'flat') return;

    var tarjetas = grid.children.length;
    if (tarjetas < 2) return;

    H.media(function (ctx) {
      /* Solo donde el contenido se sale: si caben todas, arrastrar no aporta
         nada y además rompe el scroll vertical. */
      if (ctx.escritorio) return;

      grid.classList.add('hauser-similares--arrastrable');

      var d = Draggable.create(grid, {
        type: 'x',
        edgeResistance: 0.72,
        /* InertiaPlugin está registrado en el núcleo; si no estuviera,
           Draggable simplemente no lanza y sigue funcionando el arrastre. */
        inertia: !!window.InertiaPlugin,
        bounds: { minX: -(grid.scrollWidth - grid.clientWidth), maxX: 0 },
        cursor: 'grab',
        activeCursor: 'grabbing',
        /* Sin esto, arrastrar en diagonal secuestra el scroll vertical de la
           página, que en móvil es insoportable. */
        allowNativeTouchScrolling: false,
        dragClickables: false
      });

      return function () {
        d.forEach(function (i) { i.kill(); });
        grid.classList.remove('hauser-similares--arrastrable');
        if (window.gsap) window.gsap.set(grid, { x: 0 });
      };
    });
  }

  H.listo(function () {
    precioMorfa();
    specs();
    amenidades();
    similares();
  });
})();
